// TODO: after add redux, this file must remove!
import { Shoot } from '../Types/Booking/Shoot';

const shoots: Shoot[] = [
	{
		id: 23,
		title: 'خانوادگی',
		avatar: {
			url: '/uploads/shoot_type/avatar/23/famili.png',
		},
		is_personal: true,
		order: 6,
		is_business: false,
	},
	{
		id: 24,
		title: 'غیره',
		avatar: {
			url: '/uploads/shoot_type/avatar/24/other.png',
		},
		is_personal: true,
		order: 100,
		is_business: true,
	},
	{
		id: 21,
		title: 'ورزشی',
		avatar: {
			url: '/uploads/shoot_type/avatar/21/footb.png',
		},
		is_personal: true,
		order: 99,
		is_business: true,
	},
	{
		id: 3,
		title: 'دو نفره',
		avatar: {
			url: '/uploads/shoot_type/avatar/3/date.png',
		},
		is_personal: true,
		order: 6,
		is_business: false,
	},
	{
		id: 1,
		title: 'فارغ التحصیلی',
		avatar: {
			url: '/uploads/shoot_type/avatar/1/col.png',
		},
		is_personal: true,
		order: 8,
		is_business: false,
	},
	{
		id: 27,
		title: 'خط تولید',
		avatar: {
			url: '/uploads/shoot_type/avatar/27/indust.png',
		},
		is_personal: false,
		order: 4,
		is_business: true,
	},
	{
		id: 26,
		title: 'عقد و عروسی',
		avatar: {
			url: '/uploads/shoot_type/avatar/26/wed.png',
		},
		is_personal: true,
		order: 5,
		is_business: false,
	},
	{
		id: 6,
		title: 'بارداری',
		avatar: {
			url: '/uploads/shoot_type/avatar/6/matern.png',
		},

		is_personal: true,
		order: 4,
		is_business: false,
	},
	{
		id: 2,
		title: 'کودک',
		avatar: {
			url: '/uploads/shoot_type/avatar/2/kids.png',
		},
		is_personal: true,
		order: 1,

		is_business: false,
	},
	{
		id: 9,
		title: 'تیمی و شرکتی',
		avatar: {
			url: '/uploads/shoot_type/avatar/9/team.png',
		},
		is_personal: false,
		order: 3,
		is_business: true,
	},
	{
		id: 19,
		title: 'غذا و رستورانی',
		avatar: {
			url: '/uploads/shoot_type/avatar/19/food.png',
		},
		is_personal: false,
		order: 10,
		is_business: true,
	},
	{
		id: 8,
		title: 'خبری و رویداد',
		avatar: {
			url: '/uploads/shoot_type/avatar/8/ev.png',
		},
		is_personal: true,
		order: 8,
		is_business: true,
	},
	{
		id: 18,
		title: 'تبلیغاتی-محصول',
		avatar: {
			url: '/uploads/shoot_type/avatar/18/prod.png',
		},
		is_personal: false,
		order: 5,
		is_business: true,
	},
	{
		id: 4,
		title: 'تولد - مهمانی - دورهمی',
		avatar: {
			url: '/uploads/shoot_type/avatar/4/anni.png',
		},
		is_personal: true,
		order: 4,
		is_business: false,
	},
	{
		id: 16,
		title: 'معماری-فضای داخلی',
		avatar: {
			url: '/uploads/shoot_type/avatar/16/realstate.png',
		},
		is_personal: false,
		order: 97,
		is_business: true,
	},
	{
		id: 32,
		title: 'صنعتی - زمینه سفید',
		avatar: {
			url: '/uploads/shoot_type/avatar/32/wbg.png',
		},
		is_personal: false,
		order: 5,
		is_business: true,
	},
	{
		id: 7,
		title: 'چهره - پروفایل',
		avatar: {
			url: '/uploads/shoot_type/avatar/7/personal.png',
		},
		is_personal: true,
		order: 1,
		is_business: true,
	},
	{
		id: 31,
		title: 'نوزاد',
		avatar: {
			url: '/uploads/shoot_type/avatar/31/baby.png',
		},
		is_personal: true,
		order: 1,
		is_business: false,
	},
	{
		id: 28,
		title: 'پوشاک و لباس',
		avatar: {
			url: '/uploads/shoot_type/avatar/28/fash.png',
		},
		is_personal: false,
		order: 6,
		is_business: true,
	},
];
export default shoots;
